// Wave AW.3-React (2026-05-16) — 외부 바이어 경매 카드
// ERP AuctionCard.js 와 별개 (admin/seller 분기 제거, 순수 buyer view)

import React, { useState } from 'react';
import AuthImage from './AuthImage';
import { authBuyerFetch } from './buyerApi';
import { API } from '../../utils/api';

function formatKrw(n) {
  if (n == null) return '-';
  return Number(n).toLocaleString() + '원';
}
function formatMileage(km) {
  if (km == null) return '';
  return Number(km).toLocaleString() + ' km';
}

// 남은 시간 — D-N 또는 HH:MM
function formatRemaining(endsAt) {
  if (!endsAt) return '';
  var end = new Date(endsAt).getTime();
  var now = Date.now();
  var diff = end - now;
  if (diff <= 0) return '마감';
  var d = Math.floor(diff / 86400000);
  var h = Math.floor((diff % 86400000) / 3600000);
  var m = Math.floor((diff % 3600000) / 60000);
  if (d > 0) return 'D-' + d;
  if (h > 0) return h + '시간 ' + m + '분';
  return m + '분';
}

function AuctionBuyerCard(props) {
  var auction = props.auction || {};
  var onClick = props.onClick;
  var onFavoriteChange = props.onFavoriteChange;

  // Wave AW.3-React Wave 3 fix (2026-05-16) — mask 응답 키 정합.
  // mask.buildPublicAuctionResponse 는 top-level myFavorited (boolean) / myBid (object) 만 노출,
  // myStatus 키 없음. Wave 1 이후 카드 진입 시 즐겨찾기 별/본인 입찰 뱃지 자동 표시 누락 버그 회귀 가드.
  var initialIsFav = !!auction.myFavorited;
  var [isFav, setIsFav] = useState(initialIsFav);
  var [favLoading, setFavLoading] = useState(false);

  var car = auction.car || {};
  var liveStats = auction.liveStats || {};

  // 첫 사진 — 인증 endpoint path
  var photoPath = (auction.photos && auction.photos.length > 0)
    ? ('/buyer-app/auction/' + auction.id + '/photo/0')
    : null;

  var toggleFav = function(e) {
    e.stopPropagation();
    if (favLoading) return;
    setFavLoading(true);
    var prev = isFav;
    setIsFav(!prev);
    authBuyerFetch(API + '/buyer-app/auction/' + auction.id + '/favorite', { method: 'POST' })
      .then(function(r) { return r.json(); })
      .then(function(d) {
        // Wave AW.3-React Wave 4 fix (2026-05-16) — 토글 응답 키 정합.
        // POST /buyer-app/auction/:id/favorite 응답: { success, data: { favorited, favoriteCount } }
        // 기존: d.isFavorite (undefined) → !!undefined → 항상 false → optimistic update 후 빈 별로 rollback.
        if (d && d.success) {
          var favorited = !!(d.data && d.data.favorited);
          setIsFav(favorited);
          if (onFavoriteChange) onFavoriteChange(auction.id, favorited);
        } else {
          setIsFav(prev);
        }
      })
      .catch(function() { setIsFav(prev); })
      .finally(function() { setFavLoading(false); });
  };

  var bidCount = liveStats.bidCount || 0;
  var favCount = liveStats.favoriteCount || 0;
  // mask 응답: liveStats.highestBid (top-level highestBid 아님).
  var highestBid = (auction.highestBid != null ? auction.highestBid : liveStats.highestBid) || 0;
  // mask 응답: auction.myBid = { amount, status, ... } (myStatus 아님).
  var myBidAmount = auction.myBid && auction.myBid.amount;
  var remaining = formatRemaining(auction.endsAt);

  return (
    <div onClick={function() { if (onClick) onClick(auction); }}
      style={{
        background: 'white', borderRadius: 12,
        border: '1px solid #e2e8f0',
        cursor: 'pointer',
        overflow: 'hidden',
        transition: 'box-shadow 0.15s, transform 0.15s',
        display: 'flex', flexDirection: 'column',
      }}
      onMouseEnter={function(e) {
        e.currentTarget.style.boxShadow = '0 8px 20px rgba(15,23,42,0.08)';
        e.currentTarget.style.transform = 'translateY(-2px)';
      }}
      onMouseLeave={function(e) {
        e.currentTarget.style.boxShadow = 'none';
        e.currentTarget.style.transform = 'none';
      }}>
      {/* 썸네일 */}
      <div style={{ position: 'relative', width: '100%', aspectRatio: '4/3', background: '#f1f5f9' }}>
        {photoPath ? (
          <AuthImage path={photoPath} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
        ) : (
          <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8', fontSize: 13 }}>
            사진 없음
          </div>
        )}
        {/* 즐겨찾기 토글 */}
        <button type="button" onClick={toggleFav}
          style={{
            position: 'absolute', top: 10, right: 10,
            width: 36, height: 36,
            background: 'rgba(255,255,255,0.92)',
            border: 'none', borderRadius: '50%',
            cursor: favLoading ? 'wait' : 'pointer',
            fontSize: 18,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
          }}>
          {isFav ? '⭐' : '☆'}
        </button>
        {/* 남은 시간 */}
        {remaining && (
          <div style={{
            position: 'absolute', bottom: 10, left: 10,
            background: 'rgba(15,23,42,0.75)', color: 'white',
            padding: '4px 10px', borderRadius: 6,
            fontSize: 12, fontWeight: 700,
          }}>
            {remaining}
          </div>
        )}
        {/* 내 입찰 뱃지 */}
        {myBidAmount && (
          <div style={{
            position: 'absolute', top: 10, left: 10,
            background: '#3b82f6', color: 'white',
            padding: '4px 10px', borderRadius: 6,
            fontSize: 11, fontWeight: 700,
          }}>
            내 입찰 {formatKrw(myBidAmount)}
          </div>
        )}
      </div>

      {/* 정보 */}
      <div style={{ padding: 14, display: 'flex', flexDirection: 'column', gap: 6 }}>
        <div style={{ fontSize: 15, fontWeight: 800, color: '#0f172a', lineHeight: 1.3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {car.year ? car.year + ' ' : ''}{car.model || auction.title || '경매 차량'}
        </div>
        <div style={{ fontSize: 12, color: '#94a3b8', display: 'flex', gap: 8 }}>
          {car.number && <span>{car.number}</span>}
          {formatMileage(car.mileage) && <span>·</span>}
          {formatMileage(car.mileage) && <span>{formatMileage(car.mileage)}</span>}
        </div>
        <div style={{ marginTop: 6, display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
          <div style={{ fontSize: 11, color: '#94a3b8' }}>최고가</div>
          <div style={{ fontSize: 17, fontWeight: 800, color: '#1B3A5C' }}>
            {highestBid > 0 ? formatKrw(highestBid) : <span style={{ color: '#94a3b8', fontSize: 13 }}>입찰 없음</span>}
          </div>
        </div>
        <div style={{ marginTop: 8, paddingTop: 8, borderTop: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#94a3b8' }}>
          <span>입찰 {bidCount}</span>
          <span>즐겨찾기 {favCount}</span>
        </div>
      </div>
    </div>
  );
}

export default AuctionBuyerCard;
